import PrepareUser from '../PrepareUser';

function UserLabel({ user }) {
    const { displayedName } = user;

    return <span>{displayedName}</span>;
}

export default PrepareUser(UserLabel); // eslint-disable-line new-cap
